/** The landing step's NPI check. The NPI lookup applies the backend's rule
 * (is_valid_npi_number), which also turns test NPIs down in production. */

/** Test NPIs start with 999 and skip the checksum. */
const isTestNpi = (npi: string) => npi.startsWith("999");

/** CMS's check digit: Luhn over the NPI with the 80840 prefix. */
const hasValidCheckDigit = (npi: string) => {
  const digits = `80840${npi}`;
  let sum = 0;
  for (let i = 0; i < digits.length; i++) {
    let digit = Number(digits[digits.length - 1 - i]);
    if (i % 2 === 1) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
  }
  return sum % 10 === 0;
};

/** 10 digits with a valid check digit, or a test NPI. */
export const isValidNpi = (npi: string): boolean => {
  if (!/^\d{10}$/.test(npi)) return false;
  return isTestNpi(npi) || hasValidCheckDigit(npi);
};
